import { Fragment } from 'react';

import InviteAppModal from '../InviteAppModal';
import UpgradeAccountModal from '../UpgradeAccountModal';
import { UserOnboardingPropTypes } from './UserOnboardingPropTypes';

const UserOnboardingRootView = (_: UserOnboardingPropTypes) => (
  <Fragment>
    <UpgradeAccountModal />
    <InviteAppModal />
  </Fragment>
);

export default UserOnboardingRootView;
